<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane6.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane6.title' | translate }}</h2>
  <p copy class="wt-p">{{ 'app.pages.auth.walkthrough.pane6.body' | translate }}</p>

  <!-- Four bullets. The only pane that has four; panes 2–5, 7 and 8 have three
       and pane 1 has none. -->
  <div copy class="wt-bul">
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane6.bullet.twoApps' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane6.bullet.tier' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane6.bullet.thumb' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane6.bullet.bilingual' | translate }}</span>
    </div>
  </div>

  <!-- Two installed apps and two that are not. Inert (§12 #18). -->
  <div viz class="vstack">
    @for (app of apps; track app.labelKey) {
      <div class="vapp" [class.vapp--off]="!app.installed">
        <ion-icon [name]="app.icon" aria-hidden="true"></ion-icon>
        <span>{{ app.labelKey | translate }}</span>
        @if (app.installed) {
          <ion-icon class="vapp__tick" name="checkmark-circle" aria-hidden="true"></ion-icon>
        }
      </div>
    }
  </div>

  <!-- Em dashes on both sides, and the `12` lives inside the translated string:
       it is a claim, not a count of anything the app knows. -->
  <div viz class="vhidden">{{ 'app.pages.auth.walkthrough.pane6.hidden' | translate }}</div>

  <!-- The simplicity dial. THREE SPANS AND A CLASS — see the class docblock. -->
  <div viz class="vdial">
    <div class="vdial__t">
      <ion-icon name="options-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane6.dial.title' | translate }}</span>
    </div>
    <div class="vseg">
      @for (segment of segments; track segment.labelKey) {
        <span class="vseg__s" [class.vseg__s--on]="segment.on">{{ segment.labelKey | translate }}</span>
      }
    </div>
    <div class="vdial__n">{{ 'app.pages.auth.walkthrough.pane6.dial.note' | translate }}</div>
  </div>
</app-walkthrough-slide>
